import AccessibilityChecker from './AccessibilityChecker';

export default AccessibilityChecker;
